import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue-demi';
import { useCdnImg } from '@webplatform/cdn-image';
import {
  AbTitle,
  AbSection,
  AbButton,
  AbDescription,
  AbContainer,
} from '../../ui';
import { Spacing } from '../../../helpers/shared-props';

interface Props {
  data: {
    text?: string;
    image?: string;
    title?: string;
    button?: {
      link?: string;
      text: string;
      target?: '_blank' | '_self';
      isVisible?: true;
    };
    imageMobile?: string;
    spacing?: Spacing;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HeroSectionBanner',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: {
    text?: string;
    image?: string;
    title?: string;
    button?: {
      link?: string;
      text: string;
      target?: '_blank' | '_self';
      isVisible?: true;
    };
    imageMobile?: string;
    spacing?: Spacing;
  };
};


const { generateUrl } = useCdnImg();
const backgroundImage = computed(() =>
  generateUrl(
    props.data.image
      ? props.data.image
      : props.data.imageMobile
      ? props.data.imageMobile
      : '',
    {}
  )
);

return { __sfc: true,props, generateUrl, backgroundImage, AbTitle, AbSection, AbButton, AbDescription, AbContainer }
}

})